import React from 'react';
import { useAppDisplayModeContext, useStyles } from '@archipro-design/aria';
import DetailsTab from './DetailsTab';
import * as S from './Specifications.style';
import InformationTab from './InformationTab';
import type Product from '../../type/product';

interface SpecificationsProps {
    data: Product;
}

const Specifications = ({ data }: SpecificationsProps) => {
    const { mobile } = useAppDisplayModeContext();
    const { css } = useStyles();
    const trackingPrefix = 'product';

    const tabItems = React.useMemo(() => {
        const { PerformanceDescription, ScopeOfUseDescription, LibraryTabs } =
            data;

        const sections = [];

        const specificationsTab = LibraryTabs.find(
            (tab) => tab.Title === 'Specifications' && tab.Content
        );

        const customTabsExcludingSpecs = LibraryTabs.filter(
            (tab) => tab.Title !== 'Specifications' && tab.Content
        );

        const showInformationTab = Boolean(
            specificationsTab ||
                PerformanceDescription ||
                ScopeOfUseDescription ||
                customTabsExcludingSpecs.length
        );

        const showDetailsTab = Boolean(
            data.Categories.length ||
                data.LibraryRange ||
                data.Brand ||
                data.Designer ||
                data.Year ||
                data.WarrantyDuration ||
                data.FacetOptions.length
        );

        if (showDetailsTab) {
            const detailsTab = {
                key: `${trackingPrefix}-tab-0`,
                title: 'Details',
                content: {
                    children: <DetailsTab data={data} />,
                    key: `${trackingPrefix}-content-0`,
                },
            };

            sections.push(detailsTab);
        }

        if (showInformationTab) {
            const infoTab = {
                key: `${trackingPrefix}-information-tab`,
                title: !mobile ? '' : 'Information',
                content: {
                    children: (
                        <InformationTab
                            data={{
                                SpecificationTab: specificationsTab,
                                PerformanceDescription,
                                ScopeOfUseDescription,
                                LibraryTabs: customTabsExcludingSpecs,
                            }}
                        />
                    ),
                    key: `${trackingPrefix}-information-content`,
                },
            };

            sections.push(infoTab);
        }

        return { sections };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    return (
        <div className={css(S.SpecContentContainer)}>
            {tabItems.sections.map((p, i) => (
                <div
                    key={'product-spec-' + i}
                    className={css(S.SpecContentWrapper)}
                >
                    <div className={css(S.SpecContentTitle)}>
                        {String(p.title)}
                    </div>
                    <div key={p.key}>{p.content.children}</div>
                </div>
            ))}
        </div>
    );
};

export default Specifications;
